import * as Yup from 'yup';

const percent0to100Required = () =>
  Yup.number()
    .typeError('Invalid Beneficiary Percentage')
    .min(0, 'Invalid Beneficiary Percentage')
    .max(100, 'Invalid Beneficiary Percentage')
    .required('Required');

export const beneficiariesValidationSchema = (maxNumber?: number) =>
  Yup.object({
    beneficiaries: Yup.array()
      .of(
        Yup.object({
          id: Yup.string(),
          address: Yup.string().when('id', {
            is: (id: string) => !!id,
            then: (schema) => schema.required('Required'),
            otherwise: (schema) => schema
          }),
          beneficiaryPercentage: Yup.mixed().when('id', {
            is: (id: string) => !!id,
            then: () => percent0to100Required(),
            otherwise: (schema) => schema.notRequired()
          })
        })
      )
      .test('max-count', 'Too many Beneficiaries', (arr) => {
        return !maxNumber || (Array.isArray(arr) && arr.length <= maxNumber);
      })
      .test('sum-100', null, (arr, ctx) => {
        if (!Array.isArray(arr)) return true;

        const filled = arr.filter((row) => !!row?.id);
        if (filled.length === 0) return true;

        const total = filled.reduce(
          (s, r: any) => s + Number(r?.beneficiaryPercentage || 0),
          0
        );
        if (total !== 100) {
          return ctx.createError({
            path: `${ctx.path}[${arr.length - 1}].beneficiaryPercentage`,
            message: 'Beneficiary percentages shall sum to 100%'
          });
        }

        return true;
      })
  });
